export const createNavigation = () => {
    return {
        createLink: (link) => ({
            type: 'link',
            ...link,
        }),
        createAction: (action) => ({
            type: 'button',
            ...action,
        }),
        createPopover: (popover) => ({
            type: 'popover',
            ...popover,
        }),
    };
};
